import { useFeature } from 'src/app/FeatureToggle';
import { TabNavigation } from 'src/common/TabNavigation';

const tabs = [
  { name: 'Organization Settings', href: '/settings' },
  { name: 'Tags', href: '/settings/tags' },
  { name: 'Filter Groups', href: '/settings/filter-groups' },
  {
    name: 'SMS Settings',
    href: '/settings/messages',
  },
];

const paymentsTab = {
  name: 'Payments',
  href: '/settings/payments',
};

const geolocationsTab = {
  name: 'Geolocations',
  href: '/settings/geolocations',
};

const tripRequestFormTab = {
  name: 'Trip Request Form',
  href: '/settings/trip-request-form',
};

export function SettingsNav() {
  const { isLoading, isEnabled } = useFeature('tilled payment capture');
  const { isLoading: geolocationsLoading, isEnabled: geolocationsEnabled } =
    useFeature('geolocations');
  const {
    isLoading: tripRequestFormLoading,
    isEnabled: tripRequestFormEnabled,
  } = useFeature('trip request form');

  const mergedTabs = [...tabs];

  if (!isLoading && isEnabled) {
    mergedTabs.push(paymentsTab);
  }

  if (!geolocationsLoading && geolocationsEnabled) {
    mergedTabs.push(geolocationsTab);
  }

  if (!tripRequestFormLoading && tripRequestFormEnabled) {
    mergedTabs.push(tripRequestFormTab);
  }

  return <TabNavigation tabs={mergedTabs} />;
}
